import { useMutationHandler } from "@sinch/hooks/useMutationHandler";
import { CopyRatelist, CreateRate, DeleteRatelist, EditRate } from "./queries.graphql";
import {
  CopyRatelistMutation,
  CopyRatelistMutationVariables,
  DeleteRatelistMutation,
  DeleteRatelistMutationVariables,
} from "./queries.types";
import type {
  CreateRateMutation,
  CreateRateMutationVariables,
  EditRateMutation,
  EditRateMutationVariables,
} from "./queries.types";

export const useRatelist = () => {
  const [deleteRatelist, { loading: deleting }] = useMutationHandler<
    DeleteRatelistMutation,
    DeleteRatelistMutationVariables
  >(DeleteRatelist);

  const [copyRatelist, { loading: coping }] = useMutationHandler<CopyRatelistMutation, CopyRatelistMutationVariables>(
    CopyRatelist
  );

  const [create, { loading: creating }] = useMutationHandler<CreateRateMutation, CreateRateMutationVariables>(
    CreateRate
  );

  const [update, { loading: updating }] = useMutationHandler<EditRateMutation, EditRateMutationVariables>(EditRate);

  return {
    update,
    remove: deleteRatelist,
    copy: copyRatelist,
    create,
    loading: deleting || coping || creating || updating,
  };
};
